// BAG CRAP: count taps on collection-page tools in GA4 (Amanda, Oct 18, 2026), to review in 2-3 weeks.
// Events: chip_click (chip, chip_position, from_collection), sort_open, sort_select (sort_by), view_toggle (view).
// GA4 shows event counts right away; to break them down by chip / sort / view, register those
// event parameters as custom dimensions in GA4 Admin (needs Amanda's OK).
(function () {
  var m = location.pathname.match(/^\/collections\/([^\/?#]+)/);
  var handle = m ? m[1] : "";
  // Chips also show on product pages (Oct 18, 2026); page_type tells the two apart in GA4.
  var pageType = /\/products\//.test(location.pathname) ? "product" : "collection";

  function ga(name, params) {
    try {
      if (typeof window.gtag === "function") {
        window.gtag("event", name, Object.assign({ collection: handle, page_type: pageType, transport_type: "beacon" }, params || {}));
      }
    } catch (e) {}
  }

  // Bubble phase: collection.js has already opened/closed the menu or switched the view by now.
  document.addEventListener("click", function (event) {
    var t = event.target;
    if (!t.closest) return;

    var chip = t.closest(".bcn-chips .bcn-chip");
    if (chip) {
      var all = Array.prototype.slice.call(document.querySelectorAll(".bcn-chips .bcn-chip"));
      ga("chip_click", {
        chip: chip.textContent.trim(),
        chip_position: all.indexOf(chip) + 1,
        from_collection: handle,
      });
      return;
    }

    var option = t.closest("#sort-form .sort-select a");
    if (option) {
      ga("sort_select", { sort_by: option.getAttribute("data-sort") || option.textContent.trim() });
      return;
    }

    if (t.closest(".bcn-filters .sort-btn")) {
      if (document.querySelector("#sort-form .sort-select.active")) ga("sort_open");
      return;
    }

    if (t.closest(".toggle-view-btn")) {
      var loop = document.querySelector(".loop");
      var view = "view_1";
      if (loop && loop.classList.contains("toggle-one")) view = "view_2";
      else if (loop && loop.classList.contains("toggle-two")) view = "view_3";
      ga("view_toggle", { view: view });
    }
  });
})();
